'use client';

import React from 'react';
import styles from './Accordion.module.css';

interface AccordionProps {
    /** Class name for the wrapper. */
    className?: string;
    /** This is the children that are passed in to the accordion. This has to be AccordionItems. */
    children: React.ReactNode;
    /** This is to allow the option of only displaying headings on mobile only. */

}

const Accordion = ({
    children,
    className = '',
}: AccordionProps) => (
    <ul
        className={`${styles.accordion} ${className}`}
    >
        {children}
    </ul>
);

export default Accordion;
